import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { usePartnerShares } from '../context/PartnerSharesContext';

const PartnerSharesTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerShares();

  const columns = [
    { key: 'number', content: t('Nr') },

    { key: 'shares-count', content: t('NrPart.'), textPosition: 'right' },

    !data.isCoOwner && {
      key: 'nominal-value',
      content: t('Nominal'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    data.isCoOwner && {
      key: 'encumbrance-type',
      content: t('EncumbranceType'),
      hideOnMobile: true,
    },

    {
      key: 'holding-class-name',
      content: t('Class'),
      hideOnMobile: true,
    },

    {
      key: 'from',
      content: t('From'),
      textPosition: 'right',
    },

    {
      key: 'to',
      content: t('To'),
      textPosition: 'right',
    },

    data.showEncumbranceColumn && {
      key: 'encumbrances',
      content: t('Encumbrance'),
      textPosition: 'center',
      hideOnMobile: true,
    },

    data.showSharesTitleColumn && {
      key: 'shares-title',
      content: t('Title'),
      textPosition: 'center',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default PartnerSharesTableHeader;
